import CandidateTableCard from './CandidateTableCard';

export default CandidateTableCard;



// WEBPACK FOOTER //
// ./src/components/CandidateTableCard/index.js